<div class="member-toggle-container">
  <mat-icon class="toggle-icon" fontSet="material-symbols" [inline]="true"
    >published_with_changes</mat-icon
  >

  <h2>Switched Accounts</h2>
  <p>
    Successfully switched from <strong>{{ oldPartyName }}</strong> to
    <strong>{{ newPartyName }}</strong
    >.
  </p>

  <mat-dialog-actions>
    <button
      mat-flat-button
      color="primary"
      class="toggle-member-dismiss"
      style="background-color: #65c9da; color: #ffffff"
      data-cy="member-toggle-dismiss-button"
      (click)="confirm(true)"
    >
      Dismiss
    </button>
  </mat-dialog-actions>
</div>
